(() => {
  $crisp.push([
    'on',
    'session:loaded',
    () => {
      // set metadata first so it's not skipped if any of the cosmetic DOM code below throws
      $crisp.push(['set', 'session:data', [[['last-viewed', document.title]]]]);

      let status = $crisp.is('website:available') ? 'online' : 'offline';
      const now = new Date();
      const dateString = now.toLocaleString('en-US', { timeZone: 'America/Chicago', hour12: false });
      const [datePart, timePart] = dateString.split(', ');
      const [month, dayOfMonth, year] = datePart.split('/').map(Number);
      const [hour, minute] = timePart.split(':').map(Number);
      const dateObject = new Date(
        `${year}-${month.toString().padStart(2, '0')}-${dayOfMonth.toString().padStart(2, '0')}T${hour
          .toString()
          .padStart(2, '0')}:${minute.toString().padStart(2, '0')}:00`
      );
      const day = dateObject.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday

      let onlineStatus = 'offline';
      if (day !== 0 && day !== 6 && hour >= 8 && hour < 17) {
        onlineStatus = 'online';
      }
      if (month === 12 && dayOfMonth >= 24 && dayOfMonth <= 26) {
        onlineStatus = 'offline';
      }
      if (month === 1 && dayOfMonth === 1) {
        onlineStatus = 'offline';
      }

      // start confusion: I have no idea why this is here and dont have time to debug it
      status = onlineStatus;
      if (status === 'online') {
        if (document.getElementById('status'))
          document.getElementById('status').innerText = 'Live chat with a team member';
        if (document.getElementById('footer__status'))
          document.getElementById('footer__status').innerHTML =
            '<div style="display: flex;align-items: center;position: absolute;justify-content: center;top: 0;font-size: 10px;left: 6px;"><div style="border-radius: 50%;height: 6px;width: 6px;/* position: absolute; */flex-shrink: 0;background: var(--fp-lime);margin-right: 3px;/* margin-left: -3px; */">&nbsp;</div>online</div>Start Chat';
        if (document.getElementById('contact__status'))
          document.getElementById('contact__status').innerHTML =
            '<div style="display: flex;align-items: center;position: absolute;justify-content: center;top: 0;font-size: 10px;left: 6px;"><div style="border-radius: 50%;height: 6px;width: 6px;/* position: absolute; */flex-shrink: 0;background: var(--fp-lime);margin-right: 3px;/* margin-left: -3px; */">&nbsp;</div>online</div>Start Chat';
        Array.from(document.querySelectorAll('.js-help-message')).forEach(
          (statusElement) => (statusElement.innerText = 'Live chat with a team member')
        );
      }
      // end confusion

      const chatWithUsText = onlineStatus === 'online' ? 'Chat with us' : 'Leave a message';
      const crispButton =
        document.querySelector('#crisp-chatbox-button') ||
        document.querySelector('.crisp-client div[aria-label="Open chat"]');
      if (crispButton) {
        crispButton.style.setProperty('display', 'flex', 'important');
        crispButton.style.setProperty('align-items', 'center', 'important');
        crispButton.style.setProperty('background', 'var(--fp-cta-gradient)', 'important');
        crispButton.style.setProperty('border-radius', '99vh', 'important');
        crispButton.style.setProperty('box-shadow', 'var(--fp-shadow-hover)', 'important');
        // Crisp paints its own theme-green circle behind the icon; clear it so only our brand pill shows.
        crispButton.querySelectorAll('span').forEach((el) => {
          el.style.setProperty('background-color', 'transparent', 'important');
          el.style.setProperty('box-shadow', 'none', 'important');
        });
      }
      if (crispButton && onlineStatus === 'online') {
        const dot = document.createElement('p');
        dot.className = `crisp-mobile-hidden online-indicator online-indicator--active js-online-indicator`;
        dot.style.setProperty('position', 'absolute', 'important');
        dot.style.setProperty('bottom', '1px', 'important');
        dot.style.setProperty('right', '3px', 'important');
        dot.style.setProperty('border-radius', '50%', 'important');
        dot.style.setProperty('display', 'flex', 'important');
        dot.style.setProperty('align-items', 'center', 'important');
        dot.style.setProperty('gap', '4px', 'important');
        dot.style.setProperty('margin', '0', 'important');
        dot.style.setProperty('font-size', '12px', 'important');
        dot.style.setProperty('color', 'var(--lime)', 'important');
        dot.innerHTML = `
            <span 
                class="online-indicator__dot" 
                style="
                    border: 1px solid white !important; 
                    flex-shrink: 0 !important; 
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    width: 10px !important;
                    height: 10px !important;
                    margin: 0 !important;
                    background-color: var(--fp-lime) !important;
                    border-radius: 50% !important;
                    position: relative !important;
                "
            >
                <span 
                    class="online-indicator__blink" 
                    style="
                        display: block !important;
                        width: 100% !important;
                        height: 100% !important;
                        background-color: var(--fp-lime) !important;
                        border-radius: 50% !important;
                        animation: blink 3s linear infinite !important;
                    "
                >
            </span>
        </span>`;
        crispButton.appendChild(dot);
      }

      if (crispButton && window.innerWidth > 1024) {
        crispButton.style.setProperty('padding-right', '16px', 'important');
        const chatWithUsElement = document.createElement('span');
        chatWithUsElement.innerText = chatWithUsText;
        chatWithUsElement.className = 'crisp-mobile-hidden';
        chatWithUsElement.style.setProperty('color', 'white', 'important');
        chatWithUsElement.style.setProperty('font-family', 'Roboto, sans-serif', 'important');
        chatWithUsElement.style.setProperty('font-size', '19px', 'important');
        chatWithUsElement.style.setProperty('font-weight', '700', 'important');
        crispButton.appendChild(chatWithUsElement);
      }

      window.toggleIndicators();
      $crisp.push([
        'on',
        'chat:opened',
        () => {
          const merchantWidget = document.querySelector('#google-merchantwidget-iframe-wrapper');
          if (merchantWidget) merchantWidget.style.zIndex = '50';
        },
      ]);
      $crisp.push([
        'on',
        'chat:closed',
        () => {
          const merchantWidget = document.querySelector('#google-merchantwidget-iframe-wrapper');
          if (merchantWidget) merchantWidget.style.zIndex = '2147483647';
        },
      ]);
    },
  ]);
})();
